module.exports = __webpack_public_path__ + "img/banner_Household.13969001.png";